import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  select(event) {
    const emoji = event.currentTarget.dataset.emoji
    if (!emoji) return

    this.inputTarget.value = emoji
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))

    this.element.querySelectorAll("[data-emoji]").forEach(el => {
      el.classList.remove("ring-2", "ring-blue-500", "scale-110")
    })
    event.currentTarget.classList.add("ring-2", "ring-blue-500", "scale-110")
  }
}
